import { DownOutlined } from '@ant-design/icons'
import { Button, Dropdown, Menu } from 'antd'
import { uniqBy } from 'lodash'
import { D4_Coproprietaire, D4_Matriculeics, Maybe } from '../../types'

const menuRib = ({ matricules }: { matricules: D4_Matriculeics[] | undefined }) => {
  if (!matricules) return <div />
  return (
    <Menu>
      {matricules.map((matricule) => (
        <Menu.Item key={matricule.id}>
          <Button
            type="text"
            onClick={() =>
              window.open(
                `https://vision.d4immobilier.fr/EnvoiMailRIB?idCopropriete=${matricule.copropriete?.id}&idCoproprietaire=${matricule?.coproprietaire?.id}`
              )
            }
          >
            {matricule.copropriete?.trigramme} Envoyer RIB
          </Button>
        </Menu.Item>
      ))}
    </Menu>
  )
}

const menuEnvoyerMailDemat = ({ matricules }: { matricules: D4_Matriculeics[] | undefined }) => {
  if (!matricules) return <div />
  return (
    <Menu>
      {matricules.map((matricule) => (
        <Menu.Item key={matricule.id}>
          <Button
            type="text"
            onClick={() =>
              window.open(
                `https://vision.d4immobilier.fr/EnvoiMailDemandeAutorisationDemat?permalink=${matricule?.permalink}`
              )
            }
          >
            {matricule.copropriete?.trigramme} Envoyer RIB
          </Button>
        </Menu.Item>
      ))}
    </Menu>
  )
}

const menuCompta = ({ matricules }: { matricules: D4_Matriculeics[] | undefined }) => {
  if (!matricules) return <div />
  return (
    <Menu>
      {matricules.map((matricule) => (
        <Menu.Item key={matricule.id}>
          <Button
            type="text"
            onClick={() =>
              window.open(
                `https://extranet2.ics.fr/login_externe.php?login=${matricule?.login}&mdp=${matricule?.passwd}&groupe=d4immo&rgpd=0`
              )
            }
          >
            {matricule.copropriete?.trigramme} Compta
          </Button>
        </Menu.Item>
      ))}
    </Menu>
  )
}

const menuRefusDemat = ({ matricules }: { matricules: D4_Matriculeics[] | undefined }) => {
  if (!matricules) return <div />
  return (
    <Menu>
      {matricules.map((matricule) => (
        <Menu.Item key={matricule.id}>
          <Button
            type="text"
            onClick={() =>
              window.open(`http://vision.d4immobilier.fr/?RefuserDemat?id=${matricule.matricule}&contenu=0`)
            }
          >
            {matricule.copropriete?.trigramme} Refus demat
          </Button>
        </Menu.Item>
      ))}
    </Menu>
  )
}

const Actions = ({
  coproprietaire,
  actif,
}: {
  coproprietaire: Maybe<D4_Coproprietaire> | undefined
  actif: boolean
}) => {
  if (!coproprietaire) return null

  const lots = uniqBy(coproprietaire?.lot_coproprietaires, 'lot.copropriete.id')

  return (
    <div style={{ display: 'flex', gap: '6px', justifyContent: 'center', margin: '10px 0px', flexWrap: 'wrap' }}>
      {coproprietaire.matricules.length > 1 ? (
        <Dropdown overlay={menuCompta({ matricules: coproprietaire.matricules })} trigger={['click']}>
          <Button type="primary" onClick={(e) => e.preventDefault()}>
            Compta <DownOutlined />
          </Button>
        </Dropdown>
      ) : (
        <Button
          type="primary"
          onClick={() =>
            window.open(
              `https://extranet2.ics.fr/login_externe.php?login=${coproprietaire?.matricules[0]?.login}&mdp=${coproprietaire?.matricules[0]?.passwd}&groupe=d4immo&rgpd=0`
            )
          }
        >
          Compta
        </Button>
      )}
      {coproprietaire.matricules.length > 1 ? (
        <Dropdown overlay={menuEnvoyerMailDemat({ matricules: coproprietaire.matricules })} trigger={['click']}>
          <Button type="primary" onClick={(e) => e.preventDefault()}>
            Envoi mail demat <DownOutlined />
          </Button>
        </Dropdown>
      ) : (
        <Button
          type="primary"
          onClick={() =>
            window.open(
              `https://vision.d4immobilier.fr/EnvoiMailDemandeAutorisationDemat?permalink=${coproprietaire?.matricules[0]?.permalink}`
            )
          }
        >
          Envoi mail demat
        </Button>
      )}
      {coproprietaire.matricules.length > 1 ? (
        <Dropdown overlay={menuRefusDemat({ matricules: coproprietaire.matricules })} trigger={['click']}>
          <Button type="primary" onClick={(e) => e.preventDefault()}>
            Refus demat <DownOutlined />
          </Button>
        </Dropdown>
      ) : (
        <Button
          type="primary"
          onClick={() =>
            window.open(`https://vision.d4immobilier.fr/RefuserDemat?id=${coproprietaire.matricules[0]?.id}&contenu=0`)
          }
        >
          Refus demat
        </Button>
      )}
      <Button
        type="primary"
        onClick={() =>
          window.open(
            `https://vision.d4immobilier.fr/EnvoiMailCompteExtranetServlet?id=${coproprietaire?.id}&type=${
              actif ? 'login' : 'code'
            }`
          )
        }
      >
        Envoyer {actif ? 'identifiants' : "code d'activation"}
      </Button>
      {coproprietaire.matricules.length > 1 ? (
        <Dropdown overlay={menuRib({ matricules: coproprietaire.matricules })} trigger={['click']}>
          <Button type="primary" onClick={(e) => e.preventDefault()}>
            Envoyer le RIB <DownOutlined />
          </Button>
        </Dropdown>
      ) : (
        <Button
          type="primary"
          onClick={() =>
            window.open(
              `https://vision.d4immobilier.fr/EnvoiMailRIB?idCopropriete=${lots?.[0]?.lot?.copropriete?.id}&idCoproprietaire=${coproprietaire.id}`
            )
          }
        >
          Envoyer RIB
        </Button>
      )}
    </div>
  )
}

export default Actions
